import { gql } from '@apollo/client';

/**
 * Spec 0028 D — candidate documents (CV, certificate, portfolio).
 *
 * Operation names are prefixed `Erp…` so they differ from the backend field
 * names (`teacherDocuments`, `teacherDocumentText`) — codegen collapses result
 * types when they collide.
 *
 * `kind` and `extractionStatus` are plain lowercase Strings on the wire, never
 * graphene enums.
 */
export const TeacherDocumentsQuery = gql`
  query ErpTeacherDocuments($teacherId: ID!, $kind: String) {
    teacherDocuments(teacherId: $teacherId, kind: $kind) {
      id
      teacherId
      kind
      version
      originalName
      contentType
      sizeBytes
      extractionStatus
      hasText
      textChars
      isCurrent
      uploadedAt
      uploadedByName
    }
  }
`;

/** The extracted body — separate because it is large, and shown so the operator
 *  can read EXACTLY what the model read. */
export const TeacherDocumentTextQuery = gql`
  query ErpTeacherDocumentText($documentId: ID!) {
    teacherDocumentText(documentId: $documentId) {
      documentId
      extractionStatus
      text
    }
  }
`;

/** Signed, short-lived, audited on every issue — fetched on click, never cached
 *  in the list payload. */
export const TeacherDocumentDownloadUrlQuery = gql`
  query ErpTeacherDocumentDownloadUrl($documentId: ID!) {
    teacherDocumentDownloadUrl(documentId: $documentId)
  }
`;
